
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as _91slug_93YQZPwPwDU4FgBZuc83y_45fmjjiA1deKiIAVltnUukrBsMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as indexDqqVEq5FIKQ9m18ED59gR8nMJ3n3H7bpEaZG6RysG38Meta } from "/app/pages/pools/index.vue?macro=true";
import { default as configurator_45ADZrUwqbERAyrEhsSvOGShQ5w9BjtyDWWHW8doJ2BMMeta } from "/app/pages/configurator.vue?macro=true";
import { default as _91slug_93hfUyUBHMYqjNJq39n7mKp5k3Gq6BWS2EmH3FLUAy_45dwMeta } from "/app/pages/pools/[slug].vue?macro=true";
import { default as _91_46_46_46pageSlug_93XrS4J_z7WjflRWjp_ivpeMMFy0y9lWFIIEQuRK8yiGsMeta } from "/app/pages/[...pageSlug].vue?macro=true";
import { default as indexirBOTnaNwmrPfgqxKPc24VhCFOyyli1sfv0vhA8jW_AMeta } from "/app/pages/projects/index.vue?macro=true";
import { default as _91slug_93Kl_uuRNeaWspaLchyY874fDz65LocjVDGaMpBm6MELUMeta } from "/app/pages/projects/[slug].vue?macro=true";
import { default as terms_45and_45conditionsRU14D3TdeoevONy87DoGrbDHcLlYVbN3gK81tRUROX4Meta } from "/app/pages/terms-and-conditions.vue?macro=true";
import { default as component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034Meta } from "/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_es_965044352a30d1ad4c79a5b68c3ac6b8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034 } from "/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_es_965044352a30d1ad4c79a5b68c3ac6b8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "blog___nl",
    path: "/nl/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog-slug___nl",
    path: "/nl/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___fr",
    path: "/fr/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___de",
    path: "/de/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "pools___nl",
    path: "/nl/pools",
    component: () => import("/app/pages/pools/index.vue")
  },
  {
    name: "pools___en",
    path: "/en/pools",
    component: () => import("/app/pages/pools/index.vue")
  },
  {
    name: "pools___fr",
    path: "/fr/pools",
    component: () => import("/app/pages/pools/index.vue")
  },
  {
    name: "pools___de",
    path: "/de/pools",
    component: () => import("/app/pages/pools/index.vue")
  },
  {
    name: "configurator___nl",
    path: "/nl/configurator",
    component: () => import("/app/pages/configurator.vue")
  },
  {
    name: "configurator___en",
    path: "/en/configurator",
    component: () => import("/app/pages/configurator.vue")
  },
  {
    name: "configurator___fr",
    path: "/fr/configurator",
    component: () => import("/app/pages/configurator.vue")
  },
  {
    name: "configurator___de",
    path: "/de/configurator",
    component: () => import("/app/pages/configurator.vue")
  },
  {
    name: "pools-slug___nl",
    path: "/nl/pools/:slug()",
    component: () => import("/app/pages/pools/[slug].vue")
  },
  {
    name: "pools-slug___en",
    path: "/en/pools/:slug()",
    component: () => import("/app/pages/pools/[slug].vue")
  },
  {
    name: "pools-slug___fr",
    path: "/fr/pools/:slug()",
    component: () => import("/app/pages/pools/[slug].vue")
  },
  {
    name: "pools-slug___de",
    path: "/de/pools/:slug()",
    component: () => import("/app/pages/pools/[slug].vue")
  },
  {
    name: "pageSlug___nl",
    path: "/nl/:pageSlug(.*)*",
    component: () => import("/app/pages/[...pageSlug].vue")
  },
  {
    name: "pageSlug___en",
    path: "/en/:pageSlug(.*)*",
    component: () => import("/app/pages/[...pageSlug].vue")
  },
  {
    name: "pageSlug___fr",
    path: "/fr/:pageSlug(.*)*",
    component: () => import("/app/pages/[...pageSlug].vue")
  },
  {
    name: "pageSlug___de",
    path: "/de/:pageSlug(.*)*",
    component: () => import("/app/pages/[...pageSlug].vue")
  },
  {
    name: "projects___nl",
    path: "/nl/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects___en",
    path: "/en/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects___fr",
    path: "/fr/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects___de",
    path: "/de/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects-slug___nl",
    path: "/nl/projects/:slug()",
    component: () => import("/app/pages/projects/[slug].vue")
  },
  {
    name: "projects-slug___en",
    path: "/en/projects/:slug()",
    component: () => import("/app/pages/projects/[slug].vue")
  },
  {
    name: "projects-slug___fr",
    path: "/fr/projects/:slug()",
    component: () => import("/app/pages/projects/[slug].vue")
  },
  {
    name: "projects-slug___de",
    path: "/de/projects/:slug()",
    component: () => import("/app/pages/projects/[slug].vue")
  },
  {
    name: "terms-and-conditions___nl",
    path: "/nl/terms-and-conditions",
    component: () => import("/app/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    component: () => import("/app/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___fr",
    path: "/fr/terms-and-conditions",
    component: () => import("/app/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___de",
    path: "/de/terms-and-conditions",
    component: () => import("/app/pages/terms-and-conditions.vue")
  },
  {
    name: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034Meta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034
  },
  {
    name: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034Meta?.name,
    path: "/en/sitemap.xml",
    component: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034
  },
  {
    name: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034Meta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034
  },
  {
    name: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034Meta?.name,
    path: "/de/sitemap.xml",
    component: component_45stube_2W0OBz_45T2jYF53oi0vTOJf2vAEAMhQELLFtI8o034
  }
]